import { render } from "./citiesComponent.vue?vue&type=template&id=24d15dbe&scoped=true"
import script from "./citiesComponent.vue?vue&type=script&lang=js"
export * from "./citiesComponent.vue?vue&type=script&lang=js"

import "./citiesComponent.vue?vue&type=style&index=0&id=24d15dbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d15dbe"]])

export default __exports__